import CloseOutlined from '@ant-design/icons/CloseOutlined'
import DeleteOutlined from '@ant-design/icons/DeleteOutlined'
import FileTextOutlined from '@ant-design/icons/FileTextOutlined'
import PlusOutlined from '@ant-design/icons/PlusOutlined'
import UploadOutlined from '@ant-design/icons/UploadOutlined'
import UserOutlined from '@ant-design/icons/UserOutlined'
import {
  Button,
  Form,
  Input,
  message,
  Select,
  Space,
  Steps,
  Tag,
  Tooltip,
  Upload,
  Tabs,
} from 'antd'
import CloudUploadOutlined from '@ant-design/icons/CloudUploadOutlined'
import { inject, observer } from 'mobx-react'
import React, { memo, useCallback, useEffect, useState } from 'react'
import { blue, redPrimary } from '../../../../color'
import { AvatarHasName } from '../../../../components/Common/Avatar'
import SelectPeoplePopup from '../../../../components/SelectPeoplePopup/SelectPeoplePopup'
import SpinnerInlineComponent from '../../../../components/SpinnerInlineComponent'
import { ASSIGNEE_TYPE } from '../../../../constants'
import validator from '../../../../validator'
import {
  FileAction,
  FileItem,
  SignDocumentList,
} from '../../InternalDocumentSignDocDetailPage/InternalDocumentSignDocDetailPageStyled'
import {
  CustomStepIcon,
  ModalCreateSignDocWrapper,
  StepsWrapper,
  UploadFileListItem,
} from './PopupCreateSignDocStyled'

const { Step } = Steps
const { Option } = Select

const PopupCreateSignDoc = props => {
  const {
    loadingAnimationStore,
    electronicDocumentStore,
    fileStore,
    isVisiblePopupCreateSignDoc,
    handleClosePopupCreateSignDoc,
    selectPeopleStore,
    signedDocumentStore,
    authenticationStore,
  } = props

  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
  } = selectPeopleStore

  const [form] = Form.useForm()
  const [fileId, setFileId] = useState()
  const [fileList, setFileList] = useState([])
  const [annexAttachedFiles, setAnnexAttachedFiles] = useState([])
  const [electronicDocument, setElectronicDocument] = useState([])

  const { currentUser } = authenticationStore

  // vẽ ngầm canvas ký số
  const [viewPortPdf, setViewPortPdf] = useState()
  const [fileRender, setFileRender] = useState()
  const [dataSignSavis, setDataSignSavis] = useState()
  // Ký số popup
  const [isVisiblePopupSign, setIsVisiblePopupSign] = useState(false)

  const [departmentApproverList, setDepartmentApproverList] = useState([])
  const [formApproverList, setFormApproverList] = useState([])
  const [leaderApproverList, setLeaderApproverList] = useState([])
  const [numberIssuerList, setNumberIssuerList] = useState([])
  const [digitalSignerList, setDigitalSignerList] = useState([])
  const [releaserList, setReleaserList] = useState([])
  const [permission, setPermission] = useState([
    ASSIGNEE_TYPE.DEPARTMENT_APPROVER,
    ASSIGNEE_TYPE.FORM_APPROVER,
    ASSIGNEE_TYPE.LEADER_APPROVER,
    ASSIGNEE_TYPE.NUMBER_ISSUER,
    ASSIGNEE_TYPE.DIGITAL_SIGNER,
    ASSIGNEE_TYPE.RELEASER,
  ])
  const [stepsData, setStepsData] = useState([])

  useEffect(() => {
    const allSteps = [
      {
        key: 1,
        title: 'Tạo dự thảo',
        userList: currentUser
          ? [
              {
                image_id: currentUser.imageId,
                full_name: currentUser.name_lowercase,
              },
            ]
          : [],
        allowDeleted: false,
      },
      {
        key: 2,
        title: 'Trưởng phòng duyệt',
        userList: departmentApproverList || [],
        allowDeleted: true,
        assignee_type: ASSIGNEE_TYPE.DEPARTMENT_APPROVER,
        permission: 'DEPARTMENT_APPROVER',
      },
      {
        key: 3,
        title: 'Duyệt thể thức',
        userList: formApproverList || [],
        type: 'approval',
        allowDeleted: true,
        assignee_type: ASSIGNEE_TYPE.FORM_APPROVER,
        permission: 'FORM_APPROVER',
      },
      {
        key: 4,
        title: 'Lãnh đạo duyệt',
        userList: leaderApproverList || [],
        type: 'approval',
        allowDeleted: true,
        assignee_type: ASSIGNEE_TYPE.LEADER_APPROVER,
        permission: 'LEADER_APPROVER',
      },
      {
        key: 5,
        title: 'Cấp số',
        userList: numberIssuerList || [],
        type: 'approval',
        allowDeleted: true,
        assignee_type: ASSIGNEE_TYPE.NUMBER_ISSUER,
        permission: 'NUMBER_ISSUER',
      },
      {
        key: 6,
        title: 'Ký số điện tử',
        userList: digitalSignerList || [],
        type: 'approval',
        allowDeleted: true,
        assignee_type: ASSIGNEE_TYPE.DIGITAL_SIGNER,
        permission: 'DIGITAL_SIGNER',
      },
      {
        key: 7,
        title: 'Phát hành',
        userList: releaserList || [],
        type: 'approval',
        allowDeleted: false,
        assignee_type: ASSIGNEE_TYPE.RELEASER,
        permission: 'RELEASER',
      },
    ]

    const filteredSteps = allSteps.filter(
      step => !step.permission || permission.includes(step.permission)
    )

    setStepsData(filteredSteps)
  }, [
    releaserList,
    currentUser,
    departmentApproverList,
    formApproverList,
    leaderApproverList,
    numberIssuerList,
    digitalSignerList,
    permission,
  ])

  useEffect(() => {
    ;(async () => {
      await selectPeopleStore.clearSelected()
    })()
  }, [])

  useEffect(() => {
    setDepartmentApproverList([
      ...(selectUserData[ASSIGNEE_TYPE.DEPARTMENT_APPROVER] || []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.DEPARTMENT_APPROVER] || []),
      ...(selectGroupData[ASSIGNEE_TYPE.DEPARTMENT_APPROVER] || []),
    ])

    setFormApproverList([
      ...(selectUserData[ASSIGNEE_TYPE.FORM_APPROVER] || []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.FORM_APPROVER] || []),
      ...(selectGroupData[ASSIGNEE_TYPE.FORM_APPROVER] || []),
    ])

    setLeaderApproverList([
      ...(selectUserData[ASSIGNEE_TYPE.LEADER_APPROVER] || []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.LEADER_APPROVER] || []),
      ...(selectGroupData[ASSIGNEE_TYPE.LEADER_APPROVER] || []),
    ])

    setNumberIssuerList([
      ...(selectUserData[ASSIGNEE_TYPE.NUMBER_ISSUER] || []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.NUMBER_ISSUER] || []),
      ...(selectGroupData[ASSIGNEE_TYPE.NUMBER_ISSUER] || []),
    ])

    setDigitalSignerList([
      ...(selectUserData[ASSIGNEE_TYPE.DIGITAL_SIGNER] || []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.DIGITAL_SIGNER] || []),
      ...(selectGroupData[ASSIGNEE_TYPE.DIGITAL_SIGNER] || []),
    ])

    setReleaserList([
      ...(selectUserData[ASSIGNEE_TYPE.RELEASER] || []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.RELEASER] || []),
      ...(selectGroupData[ASSIGNEE_TYPE.RELEASER] || []),
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  const handleChangeFile = info => {
    if (info.fileList.length === 0) {
      form.setFieldsValue({
        file_upload: undefined,
      })
      setFileList([])
      return
    }
    const filteredFileList = info.fileList.filter(
      (elem, index, fileList) =>
        fileList.findIndex(file => file.name === elem.name) === index
    )
    setFileList(filteredFileList)
  }

  const handleChangeAnnexFile = info => {
    if (info.fileList.length === 0) {
      form.setFieldsValue({
        file_upload: undefined,
      })
      setAnnexAttachedFiles([])
      return
    }
    const filteredFileList = info.fileList.filter(
      (elem, index, fileList) =>
        fileList.findIndex(file => file.name === elem.name) === index
    )
    setAnnexAttachedFiles(filteredFileList)
  }

  const onFinish = async values => {
    const uploadFileList = fileList
      ? fileList
          .filter(
            (elem, index, fileList) =>
              fileList.findIndex(file => file.name === elem.name) === index
          )
          .map(file => file.originFileObj)
          .filter(file => file)
      : []

    const uploadAnnexFileList = annexAttachedFiles
      ? annexAttachedFiles
          .filter(
            (elem, index, fileList) =>
              fileList.findIndex(file => file.name === elem.name) === index
          )
          .map(file => file.originFileObj)
          .filter(file => file)
      : []

    const batchUploadArr = []
    const batchUploadArrAnnex = []
    uploadFileList.forEach(file => {
      const formData = new FormData()
      formData.append('file', file)
      batchUploadArr.push(fileStore.uploadFile(formData))
    })

    uploadAnnexFileList.forEach(file => {
      const formData = new FormData()
      formData.append('file', file)
      batchUploadArrAnnex.push(fileStore.uploadFile(formData))
    })
    const assigness = stepsData
      .filter(el => el.key !== 1)
      .map(el => ({
        assignee_code: el.userList[0] ? el.userList[0].id : '',
        assignee_type: el.userList[0] ? el.userList[0].assignee_type : 'USER',
        permission: el.permission,
      }))

    const permission = stepsData
      .filter(el => el.key !== 1)
      .map(el => el.permission)
      .join(',')

    try {
      loadingAnimationStore.showSpinner(true)
      const responseAttachments = await Promise.all(batchUploadArr)
      const responseAnnexAttachments = await Promise.all(batchUploadArrAnnex)
      const formData = new FormData()
      if (electronicDocument[0].isSigned === true) {
        formData.append('file', electronicDocument[0].originFileObj)
      } else {
        formData.append('file', electronicDocument[0].originFileObj)
      }
      const responseSignDoc = await fileStore.uploadFile(formData)
      const submitData = {
        title: values.title,
        attachments: responseAttachments.map(response => response.data.file_id),
        annex_attachments: responseAnnexAttachments.map(
          response => response.data.file_id
        ),
        file_id: fileId ? fileId : responseSignDoc.data.file_id,
        assignees: assigness,
        permission: permission,
        type: 'DOCUMENT',
      }
      await electronicDocumentStore.createElectronicDocument(submitData)
      form.resetFields()
      setElectronicDocument([])
      setFileList([])
      setAnnexAttachedFiles([])
      selectPeopleStore.clearSelected()
      electronicDocumentStore.clearFilter()
      await electronicDocumentStore.getElectronicDocumentList()
      handleClosePopupCreateSignDoc()
      message.success('Tạo trình ký thành công!')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const handleChangeElectronicDoc = info => {
    if (info.fileList.length === 0) return setElectronicDocument([])
    setElectronicDocument([info.fileList[info.fileList.length - 1]])
  }

  const handleRemoveStep = useCallback(
    key => {
      const newStepsData = stepsData.filter(step => step.key !== key)
      setStepsData(newStepsData)
      setPermission(
        newStepsData.filter(el => el.key !== 1).map(el => el.permission)
      )
    },
    [stepsData]
  )

  const existingStepKeys = useCallback(() => {
    return stepsData.map(step => step.key)
  }, [stepsData])

  const allSteps = [
    {
      key: 1,
      title: 'Tạo dự thảo',
      userList: currentUser
        ? [
            {
              image_id: currentUser.imageId,
              full_name: currentUser.name_lowercase,
            },
          ]
        : [],
      allowDeleted: false,
    },
    {
      key: 2,
      title: 'Trưởng phòng duyệt',
      userList: departmentApproverList ? departmentApproverList : [],
      allowDeleted: true,
      assignee_type: ASSIGNEE_TYPE.DEPARTMENT_APPROVER,
      permission: 'DEPARTMENT_APPROVER',
    },
    {
      key: 3,
      title: 'Duyệt thể thức',
      userList: formApproverList ? formApproverList : [],
      type: 'approval',
      allowDeleted: true,
      assignee_type: ASSIGNEE_TYPE.FORM_APPROVER,
      permission: 'FORM_APPROVER',
    },
    {
      key: 4,
      title: 'Lãnh đạo duyệt',
      userList: leaderApproverList ? leaderApproverList : [],
      type: 'approval',
      allowDeleted: true,
      assignee_type: ASSIGNEE_TYPE.LEADER_APPROVER,
      permission: 'LEADER_APPROVER',
    },
    {
      key: 5,
      title: 'Cấp số',
      userList: numberIssuerList ? numberIssuerList : [],
      type: 'approval',
      allowDeleted: true,
      assignee_type: ASSIGNEE_TYPE.NUMBER_ISSUER,
      permission: 'NUMBER_ISSUER',
    },
    {
      key: 6,
      title: 'Ký số điện tử',
      userList: digitalSignerList ? digitalSignerList : [],
      type: 'approval',
      allowDeleted: true,
      assignee_type: ASSIGNEE_TYPE.DIGITAL_SIGNER,
      permission: 'DIGITAL_SIGNER',
    },
    {
      key: 7,
      title: 'Phát hành',
      userList: releaserList ? releaserList : [],
      type: 'approval',
      allowDeleted: false,
      assignee_type: ASSIGNEE_TYPE.RELEASER,
      permission: 'RELEASER',
    },
  ]

  const handleAddStep = useCallback(
    key => {
      if (!key) return
      const stepToAdd = allSteps.find(step => step.key === key)
      if (stepToAdd) {
        const updatedSteps = prev => {
          const newSteps = [...prev, stepToAdd]
          newSteps.sort((a, b) => a.key - b.key)
          setPermission(
            newSteps.filter(el => el.key !== 1).map(el => el.permission)
          )
          return newSteps
        }

        setStepsData(updatedSteps)
      }
    },
    [allSteps]
  )

  const renderTitleStep = level => {
    return (
      <>
        <div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <span>{level.title}</span>
            {level.key !== 1 && (
              <Tooltip title="Chọn người dùng" color={blue}>
                <Button
                  style={{ marginLeft: 8, borderRadius: 10, borderColor: '#d9d9d9', width: 32, height: 32 }}
                  icon={<UserOutlined style={{ color: blue, fontSize: 16 }} />}
                  onClick={() =>
                    handleOpenSelectUserDepartmentPopup(level.assignee_type)
                  }
                />
              </Tooltip>
            )}
          </div>
        </div>
      </>
    )
  }

  const renderDescStep = level => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: level.allow_edit ? 6 : 14,
          marginBottom: 14,
        }}>
        {level.userList[0] ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Tag
              className={'tag-selected'}
              color={'blue'}
              closable={level.key === 1 ? false : true}
              onClose={() =>
                selectPeopleStore.handleRemoveSelect(level.userList[0])
              }>
              <AvatarHasName
                imgId={level.userList[0]?.image_id}
                size={22}
                name={level.userList[0]?.full_name}
              />
            </Tag>
          </div>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Tag style={{ borderRadius: 10 }}>Chưa gán người!</Tag>
          </div>
        )}
      </div>
    )
  }

  const handleClose = useCallback(() => {
    form.resetFields()
    setElectronicDocument([])
    setFileList([])
    setAnnexAttachedFiles([])
    selectPeopleStore.clearSelected()
    handleClosePopupCreateSignDoc()
  }, [
    form,
    electronicDocument,
    fileList,
    annexAttachedFiles,
    selectPeopleStore,
  ])

  return (
    <>
      <ModalCreateSignDocWrapper
        visible={isVisiblePopupCreateSignDoc}
        footer={null}
        closable={true}
        onCancel={handleClose}
        title={'Tạo trình ký văn bản'}
        width={1000}
        style={{ top: 60 }}>
        <SpinnerInlineComponent />
        <Form onFinish={onFinish} layout={'vertical'} name={'form'} form={form}>
          <div className="inner-form-card">
          <Form.Item
            label={'Tiêu đề'}
            name={'title'}
            rules={[
              { required: true, message: ' Vui lòng nhập tiêu đề trình ký!' },
              { validator: validator.validateInputString },
              { max: 200, message: 'Tiêu đề không được dài quá 200 kí tự' },
            ]}>
            <Input placeholder={'Nhập tiêu đề...'} style={{ borderRadius: 8, height: 40 }} />
          </Form.Item>
          <Tabs defaultActiveKey="1" style={{ marginTop: 16, marginBottom: 24 }}>
            <Tabs.TabPane tab="Tài liệu trình ký *" key="1">
              <Form.Item
                name={'electronic_document'}
                rules={[
                  { required: true, message: ' Vui lòng chọn tài liệu trình ký!' },
                ]}
                style={{ marginBottom: 0 }}
              >
                <Upload.Dragger
                  valuePropName={'fileList'}
                  fileList={fileList}
                  multiple={false}
                  beforeUpload={() => false}
                  onChange={handleChangeElectronicDoc}
                  showUploadList={false}
                  accept={'.doc,.docx,application/pdf'}
                  className="dragger-upload-custom"
                >
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <CloudUploadOutlined style={{ fontSize: 32, color: '#a0aec0', marginBottom: 8 }} />
                    <div style={{ fontSize: 14, marginBottom: 4, color: '#333' }}>
                      <span style={{ fontWeight: 500 }}>Kéo thả tài liệu trình ký, hoặc </span>
                      <span style={{ color: '#1890ff', fontWeight: 500 }}>Tải lên</span>
                    </div>
                  </div>
                </Upload.Dragger>
              </Form.Item>
              <SignDocumentList style={{ marginTop: 16 }}>
                {electronicDocument.map((file, index) => {
                  return (
                    <UploadFileListItem
                      key={file.uid || file.id}
                      isSigned={file.isSigned}
                      isNotPDF={file.type !== 'application/pdf'}>
                      <FileTextOutlined />
                      <span>{file.name}</span>
                      <Tooltip title={'Xóa'}>
                        <Button
                          type={'text'}
                          icon={<DeleteOutlined style={{ color: redPrimary }} />}
                          onClick={() => setElectronicDocument([])}
                        />
                      </Tooltip>
                    </UploadFileListItem>
                  )
                })}
              </SignDocumentList>
            </Tabs.TabPane>
            
            <Tabs.TabPane tab="Phụ lục đi kèm" key="2">
              <Form.Item name={'file'} style={{ marginBottom: 0 }}>
                <Upload.Dragger
                  valuePropName={'annex_attached'}
                  fileList={annexAttachedFiles}
                  multiple={true}
                  beforeUpload={() => false}
                  onChange={handleChangeAnnexFile}
                  showUploadList={false}
                  className="dragger-upload-custom"
                >
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <CloudUploadOutlined style={{ fontSize: 32, color: '#a0aec0', marginBottom: 8 }} />
                    <div style={{ fontSize: 14, marginBottom: 4, color: '#333' }}>
                      <span style={{ fontWeight: 500 }}>Kéo thả phụ lục đi kèm, hoặc </span>
                      <span style={{ color: '#1890ff', fontWeight: 500 }}>Tải lên</span>
                    </div>
                  </div>
                </Upload.Dragger>
              </Form.Item>
              <SignDocumentList style={{ marginTop: 16 }}>
                {annexAttachedFiles.map((file, index) => {
                  return (
                    <FileItem key={file.uid}>
                      <span>
                        <FileTextOutlined style={{ marginRight: 5 }} />
                        {file.name}
                      </span>
                      <FileAction>
                        <Tooltip title={'Xóa'}>
                          <Button
                            type={'text'}
                            icon={<DeleteOutlined style={{ color: redPrimary }} />}
                            onClick={() =>
                              setAnnexAttachedFiles(
                                annexAttachedFiles.filter(el => el.uid !== file.uid)
                              )
                            }
                          />
                        </Tooltip>
                      </FileAction>
                    </FileItem>
                  )
                })}
              </SignDocumentList>
            </Tabs.TabPane>
            
            <Tabs.TabPane tab="Tài liệu đính kèm" key="3">
              <Form.Item name={'file'} style={{ marginBottom: 0 }}>
                <Upload.Dragger
                  valuePropName={'fileList'}
                  fileList={fileList}
                  multiple={true}
                  beforeUpload={() => false}
                  onChange={handleChangeFile}
                  showUploadList={false}
                  className="dragger-upload-custom"
                >
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <CloudUploadOutlined style={{ fontSize: 32, color: '#a0aec0', marginBottom: 8 }} />
                    <div style={{ fontSize: 14, marginBottom: 4, color: '#333' }}>
                      <span style={{ fontWeight: 500 }}>Kéo thả tài liệu đính kèm, hoặc </span>
                      <span style={{ color: '#1890ff', fontWeight: 500 }}>Tải lên</span>
                    </div>
                  </div>
                </Upload.Dragger>
              </Form.Item>
              <SignDocumentList style={{ marginTop: 16 }}>
                {fileList.map((file, index) => {
                  return (
                    <FileItem key={file.uid}>
                      <span>
                        <FileTextOutlined style={{ marginRight: 5 }} />
                        {file.name}
                      </span>
                      <FileAction>
                        <Tooltip title={'Xóa'}>
                          <Button
                            type={'text'}
                            icon={<DeleteOutlined style={{ color: redPrimary }} />}
                            onClick={() =>
                              setFileList(
                                fileList.filter(el => el.uid !== file.uid)
                              )
                            }
                          />
                        </Tooltip>
                      </FileAction>
                    </FileItem>
                  )
                })}
              </SignDocumentList>
            </Tabs.TabPane>
          </Tabs>

          <div>
            <Select
              placeholder="Chọn bước để thêm"
              value={null}
              onChange={value => {
                handleAddStep(value)
              }}
              style={{ width: 300 }}>
              {allSteps
                .filter(item => item.allowDeleted)
                .map(step => (
                  <Option
                    key={step.key}
                    value={step.key}
                    disabled={existingStepKeys().includes(step.key)}>
                    {step.title}
                  </Option>
                ))}
            </Select>
          </div>

          <StepsWrapper count={stepsData.length} i={4}>
            <Steps
              status="process"
              className={'steps'}
              labelPlacement={'vertical'}
              size={'small'}>
              {stepsData.map(level => {
                return (
                  <Step
                    key={level.key}
                    title={renderTitleStep(level)}
                    description={renderDescStep(level)}
                    icon={
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <CustomStepIcon>{level.key} </CustomStepIcon>
                        {level.allowDeleted && (
                          <CloseOutlined
                            style={{ marginLeft: 6, fontSize: 12 }}
                            onClick={() => handleRemoveStep(level.key)}
                          />
                        )}
                      </div>
                    }
                  />
                )
              })}
            </Steps>
          </StepsWrapper>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: 24,
            }}>
            <Space size={16}>
              <Button 
                onClick={handleClose}
                style={{ borderRadius: 8, width: 140, height: 40 }}
              >
                Hủy tạo
              </Button>
              <Button
                htmlType={'submit'}
                type={'primary'}
                style={{ borderRadius: 8, width: 140, height: 40 }}
              >
                Tạo trình ký
              </Button>
            </Space>
          </div>
          </div>
        </Form>

        <SelectPeoplePopup
          onlyOneUser={true}
          handleCancelSelectUser={handleCancelSelectUserDepartment}
          handleSubmitSelectUser={() =>
            setIsVisibleSelectUserDepartmentPopup(false)
          }
          isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
        />
      </ModalCreateSignDocWrapper>
    </>
  )
}

PopupCreateSignDoc.propTypes = {}

export default memo(
  inject(
    'loadingAnimationStore',
    'fileStore',
    'electronicDocumentStore',
    'selectPeopleStore',
    'signedDocumentStore',
    'authenticationStore'
  )(observer(PopupCreateSignDoc))
)
